import React, { Dispatch, SetStateAction, createContext, useContext, useMemo, useState } from 'react';

export namespace AppContextNS {
  export type onLoginSucceed = (() => void) | null | undefined;
  export type setOnLoginSucceed = Dispatch<SetStateAction<AppContextNS.onLoginSucceed>>;
}

type AppContextProps = {
  onLoginSucceed?: AppContextNS.onLoginSucceed;
  setOnLoginSucceed: AppContextNS.setOnLoginSucceed;
};

const AppContext = createContext<AppContextProps>({
  setOnLoginSucceed: () => {},
});

export const useAppContext = () => useContext(AppContext);

type AppContextProviderProps = {
  children: React.ReactNode;
};

const AppContextProvider = ({ children }: AppContextProviderProps) => {
  const [onLoginSucceed, setOnLoginSucceed] = useState<AppContextNS.onLoginSucceed>(null);

  const forwardedState = useMemo(
    () => ({
      onLoginSucceed,
      setOnLoginSucceed,
    }),
    [onLoginSucceed, setOnLoginSucceed],
  );

  return <AppContext.Provider value={forwardedState}>{children}</AppContext.Provider>;
};

export default AppContextProvider;
